import * as types from './mutation-types'

export default {
    [types.LANDLORD_AUTH_SUCCESS](state, token) {
        state.token = token
        state.status = 'success'
    },

    [types.LANDLORD_AUTH_LOGOUT](state) {
        state.token = null
        state.admin = null
        state.status = ''
    },

    [types.LANDLORD_AUTH_ERROR](state) {
        state.token = null
        state.status = 'error'
    },

    [types.LANDLORD_SET_ADMIN](state, admin) {
        state.admin = admin
    }
}
